/**
 * 注册分享任务
 */
export const REGISTER_SHARE_TASK = 'REGISTER_SHARE_TASK';

/**
 * 移除分享任务
 */
export const REMOVE_SHARE_TASK = 'REMOVE_SHARE_TASK';
